import mixpanel from 'mixpanel-browser';

const isProduction = import.meta.env.VITE_ENV === 'production';

export const initMixpanel = () => {
  if (isProduction)
    mixpanel.init('2cffb608df02dc4533363855c92fe172', {
      api_host: 'https://api-eu.mixpanel.com', // eu data center
      track_pageview: false, // we don't track page views here, we do it manually
      disable_persistence: true, // don't store any data locally
      disable_notifications: true, // don't show notifications
    });
};
export const identifyUser = (userId: string, userInfo = {}) => {
  if (!userId) return;
  if (isProduction) {
    mixpanel.identify(userId);
    mixpanel.people.set(userInfo); // Set user properties
  } else {
    console.log('Tracking >> Identify user:', userId, userInfo);
  }
};

export const logoutUser = () => {
  if (isProduction) mixpanel.reset();
  else console.log('Tracking >> Reset user');
};

export const trackEvent = (eventName: TrackingEventTypes, eventProperties = {}) => {
  if (isProduction) mixpanel.track(eventName, eventProperties);
  else console.log('Tracking >> Track event:', eventName, eventProperties);
};

// enum of all the event types
export enum TrackingEventTypes {
  LOGOUT = 'Logout',
  VIEW_PATIENT_INFO = 'View Patient Information',
  ADD_PATIENT_STARTED = 'Add Patient Started',
  ADD_PATIENT_COMPLETE = 'Add Patient Complete',
  ADD_PATIENT_NEXT_STEP = 'Add Patient Next Step',
  ADD_PATIENT_INFO_STARTED = 'Add Patient Information Started',
  ADD_PATIENT_INFO_COMPLETE = 'Add Patient Information Complete',
}
